import { eventBus } from "./eventBus";
import Home from "./Home.vue";

frappe.provide("frappe.mesrajaya");

frappe.mesrajaya.job_card_web = class {
	constructor(main) {
		this.main = main;
		this.make_body();
	}
	make_body() {
		this.$el = this.main.find("#app");
		this.$vue = new Vue({
			el: this.$el[0],
			data() {
				return { doc: null };
			},
			created() {
				if (!frappe.session.user || frappe.session.user == "Guest") {
					frappe.throw(__("You are not allow to access Job Card without user login."))
				}
				const searchParams = new URLSearchParams(
					window.location.search
				);
				const hash = searchParams.get("secret");
				if (!hash) {
					frappe.throw(
						"Link has expired or broken, please get the latest link from your manager."
					);
				} else {
					this.loadDoc(hash);
				}
				eventBus.$on("load-doc", () => this.loadDoc(hash));
			},
			render(h) {
				return h(Home, {
					props: { doc: this.doc },
				});
			},
			methods: {
				loadDoc(hash) {
					frappe.freeze("Loading...");
					frappe
						.call({
							method: "mesrajaya.api.get_job_card",
							args: { hash },
						})
						.then(async (res) => {
							if (res.message.success) {
								this.doc = res.message.doc;
								frappe.unfreeze();
							} else {
								frappe.unfreeze();
								frappe.throw(res.message.message);
							}
						});
				},
			},
		});
		this.$eventBus = eventBus;
	}
	setup_header() {}
};
